// For categorizing fixes. Each level is inclusive of the one preceding it. That's why
// index is used as the value--enabling > and < comparisons to check if a kind of fix is allowed.
export const fixLevels = [
  'ERROR', // Fix failed due to an error.
  'NONE', // No changes to zone data
  'TRIVIAL', // Only fixes that change the zone shape within the Trivial Area Threshold, and no change in zone properties with areas larger than the Trivial Area Threshold
  'REVIEW' // Any fixes to zone data may be made including those that user should review to confirm.
].reduce((result, key, index) => { result[key] = index; return result; }, {});
fixLevels.name = (value) => Object.keys(fixLevels).find(fixLevelName => fixLevels[fixLevelName] === value);

// Polygons generally must be larger than this to be considered eligible for being a zone.
export const TRIVIAL_AREA_THRESHOLD = 1; // square meters
